import React from "react";
import { Loader2, Pause, Play } from "lucide-react";

/**
 * Floating circular photo button for Dr. Nesma with a state dot indicating
 * idle/loading/playing. Parent handles the click + audio state.
 */
export default function AvatarButton({ user, loading, playing, onClick }) {
  return (
    <button
      onClick={onClick}
      data-testid="teacher-avatar"
      title={user ? "Ask Dr. Nesma to read this page" : "Meet your EGNS teacher, Dr. Nesma"}
      className="relative group"
    >
      <span
        className={`absolute inset-0 rounded-full bg-sage/30 transition ${
          playing ? "animate-ping-slow" : ""
        }`}
      />
      <span className="relative block w-16 h-16 rounded-full overflow-hidden ring-4 ring-white shadow-[0_8px_20px_rgba(74,103,92,0.25)] group-hover:scale-105 transition-transform">
        <img
          src="/teacher.jpg"
          alt="Dr. Nesma — EGNS senior instructor"
          className="w-full h-full object-cover"
          draggable={false}
        />
      </span>
      <span
        className={`absolute bottom-0.5 end-0.5 inline-flex items-center justify-center w-5 h-5 rounded-full border-2 border-white ${
          playing ? "bg-terracotta" : loading ? "bg-amber-400" : "bg-sage"
        }`}
      >
        {loading ? (
          <Loader2 className="w-2.5 h-2.5 text-white animate-spin" />
        ) : playing ? (
          <Pause className="w-2.5 h-2.5 text-white" />
        ) : (
          <Play className="w-2.5 h-2.5 text-white" />
        )}
      </span>
    </button>
  );
}
